import classnames from 'classnames';
import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import { Trans, useTranslation } from 'next-i18next';
import { useRef, useState } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

const TowelRobesSection = () => {
  const { t: tTowelRobes } = useTranslation('', { keyPrefix: '$pages.$home.$towelRobesSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tCategory } = useTranslation('', { keyPrefix: '$local.$category' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bath' });

  const container = useRef<HTMLDivElement>(null);
  const tabs = ['towels', 'robes'];
  const defaultTab = tabs[1];
  const [currentTab, setCurrentTab] = useState(defaultTab);
  const [tl, setTl] = useState(null);

  useGSAP(() => {
    const defaultImg = `.tab-img-block.${defaultTab} img`;
    setTl(
      gsap
        .timeline({ paused: true })
        .set(defaultImg, { display: 'block' })
        .to(defaultImg, { opacity: 0, duration: 0.5 })
        .set(defaultImg, { display: 'none' }),
    );
  }, []);

  const switchTab = (tab: string) => () => {
    setCurrentTab(tab);
    if (tab === defaultTab) tl.reverse();
    else tl.play();
  };

  return (
    <section className="base-section bath-section hp-section" ref={container}>
      <div className="desktop-viewport">
        <div className="content-section">
          <h2>{tTowelRobes('title')}</h2>
        </div>
        <div className="stack">
          <span>
            <Trans i18nKey="stackTitle" t={tTowelRobes} components={{ span: <span /> }} />
          </span>
          <Button href={tLink('bath')} ariaLabel={tCategory('bath')}>
            {tButton('shopNow')}
          </Button>
        </div>
        <ul className="tab-buttons">
          {tabs.map(tab => (
            <li key={tab}>
              <button
                type="button"
                onClick={switchTab(tab)}
                className={classnames(tab, currentTab === tab && 'active')}
              >
                <h3>{tTowelRobes(tab)}</h3>
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-img-wrapper">
          {tabs.map(tab => (
            <div className={`tab-${tab}`} key={tab}>
              <a href={tLink(tab)}>
                <div className={`${tab} tab-img-block`}>
                  <picture>
                    <source
                      data-srcset="/images/homePage/fill.gif"
                      media="(max-width: 801px)"
                      srcSet="/images/homePage/fill.gif"
                    />
                    <img
                      className="lazy"
                      alt={tTowelRobes(tab)}
                      src={`/images/homePage/towelRobesSection/${tab}.webp`}
                      width={1440}
                      height={720}
                      loading="lazy"
                      decoding="async"
                      fetchPriority="low"
                    />
                  </picture>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default TowelRobesSection;
